import { forwardRef } from 'react';

import { Button, type ButtonProps } from '@/components/ui/Button';
import { cn } from '@/lib/utils';

export const tableActionButtonClassName = 'h-8 min-w-32 rounded-md px-3 py-0 text-sm';
export const tableIconActionButtonClassName = 'h-8 w-8 min-w-8 rounded-md p-0 text-sm';

export const TableActionButton = forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, size = 'sm', ...props }, ref) => (
    <Button ref={ref} size={size} className={cn(tableActionButtonClassName, className)} {...props} />
  )
);

TableActionButton.displayName = 'TableActionButton';

export const TableIconActionButton = forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, size = 'sm', variant = 'ghost', ...props }, ref) => (
    <Button
      ref={ref}
      size={size}
      variant={variant}
      className={cn(tableIconActionButtonClassName, className)}
      {...props}
    />
  )
);

TableIconActionButton.displayName = 'TableIconActionButton';
